<template>
  <section class="skills-block">
    <label class="skills-label">Skills (min 3)</label>
    <div class="skills-zone">
      <span v-for="(s, i) in model" :key="i" class="skill-tag">
        {{ s }}
        <button type="button" class="skill-tag-remove" @click="remove(i)" aria-label="Remove skill"><i class="fa fa-times" aria-hidden="true"></i></button>
      </span>
      <input
        v-model="newSkill"
        type="text"
        class="skills-input-inline"
        placeholder="Add skill and press Enter"
        maxlength="80"
        @keydown.enter.prevent="add"
      />
    </div>
    <span class="skills-hint">{{ model.length }} skills</span>
  </section>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  modelValue: { type: Array, default: () => [] }
});
const emit = defineEmits(['update:modelValue']);

const model = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v)
});

const newSkill = ref('');

function add() {
  const t = newSkill.value?.trim();
  if (!t) return;
  if (props.modelValue.includes(t)) {
    newSkill.value = '';
    return;
  }
  emit('update:modelValue', [...props.modelValue, t]);
  newSkill.value = '';
}

function remove(i) {
  const next = props.modelValue.filter((_, idx) => idx !== i);
  emit('update:modelValue', next);
}
</script>

<style scoped>
.skills-block {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.skills-label {
  display: block;
  font-weight: 600;
  font-size: 1rem;
  color: var(--app-text);
  margin-bottom: 10px;
}

.skills-zone {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 12px;
  align-items: center;
  padding: 20px 24px;
  min-height: 56px;
  box-sizing: border-box;
  background: var(--app-surface);
  border: 2px solid #a88bff;
  border-radius: 12px;
  box-shadow: 0 0 12px rgba(168, 139, 255, 0.35);
  transition: border-color 0.2s, box-shadow 0.2s;
}

.skills-zone:focus-within {
  border-color: #8a62ff;
  box-shadow: 0 0 16px rgba(138, 98, 255, 0.4);
  outline: none;
}

.skill-tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: #f0eefd;
  border: 1px solid rgba(127, 96, 249, 0.25);
  border-radius: 10px;
  font-size: 14px;
  color: var(--app-text);
  font-weight: 500;
}

.skill-tag-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  font-size: 12px;
  line-height: 1;
  transition: color 0.2s, background 0.2s;
}

.skill-tag-remove:hover {
  color: #7f60f9;
  background: rgba(127, 96, 249, 0.15);
}

.skills-input-inline {
  flex: 1;
  min-width: 180px;
  padding: 8px 4px;
  border: none;
  font-size: 15px;
  color: var(--app-text);
  background: transparent;
  outline: none;
}

.skills-input-inline::placeholder {
  color: var(--text-muted);
}

.skills-hint {
  display: block;
  font-size: 13px;
  color: var(--text-muted);
  margin-top: 10px;
}
</style>
